/*global _ */
import listeners from './methods/listeners'
import destroyListeners from './methods/listeners/destroy'
import StoreMixin from './store'
const mixins = [StoreMixin]

export default {
  mixins,
  props: {
    designerMode: {}
  },
  data() {
    return {
      designerObject: {},
    }
  },
  created() {
    if (this.designerMode) {
      this.enableDesignerMode()
      if (this.pageWrapperComponent) {
        destroyListeners.call(this)
      } else {
        listeners.call(this)
      }
    }
  },
  methods: {
    $$getData(path, defaultValue) {
      if (this.isDesignerMode && !_.isEmpty(this.designerObject)) {
        if (_.has(this.designerObject, path)) {
          return _.get(this.designerObject, path, defaultValue)
        }
      }
      return _.get(this, path, defaultValue)
    },
    $$getSData(path, defaultValue) {
      if (this.isDesignerMode && !_.isEmpty(this.designerObject)) {
        if (_.has(this.designerObject, path)) {
          const designerPath = 'designerSettings.' + path
          return _.get(this.designerObject, designerPath, defaultValue)
        }
      }
      return this.$$s(path, defaultValue)
    },
    $$getTData(path, prop, defaultValue) {
      if (this.isDesignerMode && !_.isEmpty(this.designerObject)) {
        const designerPath = 'designerTranslations.' + path
        if (_.has(this.designerObject, designerPath)) {
          return _.get(this.designerObject, designerPath, defaultValue)
        }
      }
      return this.$$t(path, defaultValue)
    }
  }
}
